/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { VideoCallProviderEnum } from './videoCallProviderEnum';


import {ValidatorFn, Validators} from "@angular/forms";

export interface UserAppointmentResourceUpdate { 
    administrativeDivision?: number | null;
    bookableAppointmentTypes?: Array<number>;
    defaultVideoCallProvider?: VideoCallProviderEnum;
    videoCallProviderUserId?: string;
    doctolibAgendaLabel?: string | null;
    spokenLanguages?: Array<number>;
}
export namespace UserAppointmentResourceUpdate {
}

export const UserAppointmentResourceUpdate_administrativeDivision_Validators: ValidatorFn[] =
    [ ];

export const UserAppointmentResourceUpdate_bookableAppointmentTypes_Validators: ValidatorFn[] =
    [ ];

export const UserAppointmentResourceUpdate_defaultVideoCallProvider_Validators: ValidatorFn[] =
    [ ];

export const UserAppointmentResourceUpdate_videoCallProviderUserId_Validators: ValidatorFn[] =
    [  Validators.maxLength(63),];

export const UserAppointmentResourceUpdate_doctolibAgendaLabel_Validators: ValidatorFn[] =
    [  Validators.maxLength(255),];

export const UserAppointmentResourceUpdate_spokenLanguages_Validators: ValidatorFn[] =
    [ ];


